import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "漫画库", to: "/manga" },
  { label: "资讯", to: "/news" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70 shadow-soft"
          : "bg-transparent"
      }`}
    >
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3"
        aria-label="主导航"
      >
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="樱花漫画首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-flower-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-bold text-foreground-950">
            樱花<span className="text-primary-600">漫画</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => {
            const active =
              link.to === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active
                    ? "bg-primary-100 text-primary-800 font-medium"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/contact"
            className="ml-2 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            联系我们
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-900 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 px-4 py-3 backdrop-blur md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-1 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}